import React, { memo } from 'react';
import ReactDom from 'react-dom';
const style = {
  visibility: 'hidden'
};
const Image = ({
  logoUrl
}) => {
  return /*#__PURE__*/React.createElement("div", {
    key: logoUrl,
    style: {
      maskImage: `url(${logoUrl})`,
      WebkitMaskImage: `url(${logoUrl})`
    }
  });
};
const MemoizedImage = /*#__PURE__*/memo(Image);
export const LogoCategoriesPrerenderComponent = ({
  logos
}) => {
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/ReactDom.createPortal( /*#__PURE__*/React.createElement("div", null, logos.map(logoUrl => /*#__PURE__*/React.createElement(MemoizedImage, {
    key: logoUrl,
    logoUrl: logoUrl
  }))), document.body));
};